import apiClient from "./api-client";
import { sleep } from "./util";

export const ZERO_UUID = "00000000-0000-0000-0000-000000000000";

function addUuidDashes(hexString: string) {
	if (hexString.length !== 32) {
		throw new Error("Invalid UUID length");
	}
	return `${hexString.slice(0, 8)}-${hexString.slice(8, 12)}-${hexString.slice(12, 16)}-${hexString.slice(
		16,
		20,
	)}-${hexString.slice(20, 32)}`;
}

export function base64toUuid(encodedUuid: string) {
	const chars = atob(encodedUuid);
	const charsInHex = chars
		.split("")
		.map((char) => char.charCodeAt(0).toString(16).padStart(2, "0"))
		.join("");
	return addUuidDashes(charsInHex);
}

export function uuidToIntId(uuid: string, size = 16) {
	const numbersOnly = uuid.split("-").join("");
	if (numbersOnly.length !== 32) {
		throw new Error("Invalid UUID length");
	}
	if (size > 32) {
		throw new Error("Invalid int size");
	}
	return Number(`0x${numbersOnly.slice(size * -1)}`);
}

export function intIdToUuid(id: number) {
	const numString = id.toString(16);
	if (numString.length > 32) {
		throw new Error("Invalid int size");
	}
	return addUuidDashes(numString.padStart(32, "0"));
}

export function isValidUuidString(uuid: string) {
	return uuid.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)?.[0] === uuid;
}

export async function mapAccessControlUuidToId({
	instituteIdParam,
	courseIdParam,
}: {
	instituteIdParam?: string;
	courseIdParam?: string;
}) {
	let mappedCourseId: number | undefined;
	let mappedInstituteId: number | undefined;

	if (courseIdParam) {
		const courseId = new URL(window.location.href).searchParams.get(courseIdParam);
		if (courseId && Number.isNaN(Number(courseId)) && isValidUuidString(courseId)) {
			mappedCourseId = await apiClient.course.getCourseIdFromUuid(courseId);
		}
	}
	if (instituteIdParam) {
		const instituteId = new URL(window.location.href).searchParams.get(instituteIdParam);
		if (instituteId && Number.isNaN(Number(instituteId)) && isValidUuidString(instituteId)) {
			mappedInstituteId = await apiClient.institute.getInstituteIdFromUuid(instituteId);
		}
	}
	if (mappedCourseId || mappedInstituteId) {
		const url = new URL(window.location.href);
		mappedCourseId && courseIdParam && url.searchParams.set(courseIdParam, mappedCourseId.toString());
		mappedInstituteId && instituteIdParam && url.searchParams.set(instituteIdParam, mappedInstituteId.toString());
		window.history.replaceState(window.history.state, "", url);
		window.location.reload();
		await sleep(1000);
	}
}
